import Box, { BoxProps } from "@mui/joy/Box";
import Sheet from "@mui/joy/Sheet";
import * as React from "react";
import { useLayout } from "./layoutContext";

export function Root(props: BoxProps) {
  const { sidebarCollapsed } = useLayout();
  const { sidepaneCollapsed } = useLayout();

  const sidebarColumnSm = sidebarCollapsed ? "64px" : "minmax(64px, 200px)";
  const sidebarColumnMd = sidebarCollapsed ? "64px" : "minmax(160px, 300px)";

  const sidepaneColumn = sidepaneCollapsed ? "64px" : "minmax(300px, 400px)";

  return (
    <Box
      {...props}
      sx={[
        {
          bgcolor: "background.body",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: `${sidebarColumnSm} minmax(450px, 1fr)`,
            md: `${sidebarColumnMd} ${sidepaneColumn} minmax(500px, 1fr)`,
          },
          gridTemplateRows: "64px calc(100vh - 64px)",
          minHeight: "100vh",
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}

export function Header(props: BoxProps) {
  return (
    <Box
      component="header"
      {...props}
      sx={[
        {
          gap: 2,
          bgcolor: "background.surface",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gridColumn: "1 / -1",
          borderBottom: "1px solid",
          borderColor: "divider",
          position: "sticky",
          top: 0,
          zIndex: 1100,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}

export function SideNav(props: BoxProps) {
  return (
    <Box
      component="nav"
      {...props}
      sx={[
        {
          bgcolor: "background.surface",
          borderRight: "1px solid",
          borderColor: "divider",
          display: {
            xs: "none",
            sm: "flex",
          },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}

export function SidePane(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={[
        {
          bgcolor: "background.surface",
          borderRight: "1px solid",
          borderColor: "divider",
          // display: {
          //   xs: "none",
          //   md: "initial",
          // },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}
type MainProps = { withPane?: boolean } & BoxProps;

export function Main({ withPane = true, ...props }: MainProps) {
  return (
    <Box
      component="main"
      {...props}
      sx={[
        {
          gridColumn: withPane ? "span 1" : { sm: "span 1", md: "span 2" },
          p: 2,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}

export function SideDrawer(
  props: BoxProps & { onClose: React.MouseEventHandler<HTMLDivElement> },
) {
  const { onClose, ...other } = props;
  return (
    <Box
      {...other}
      sx={[
        { position: "fixed", zIndex: 1200, width: "100%", height: "100%" },
        ...(Array.isArray(other.sx) ? other.sx : [other.sx]),
      ]}
    >
      <Box
        role="button"
        onClick={onClose}
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: (theme) =>
            `rgba(${theme.vars.palette.neutral.darkChannel} / 0.8)`,
        }}
      />
      <Sheet
        sx={{
          minWidth: 256,
          width: "max-content",
          height: "100%",
          p: 2,
          boxShadow: "lg",
          bgcolor: "background.surface",
        }}
      >
        {other.children}
      </Sheet>
    </Box>
  );
}
